import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
export function SistemaAceSection() {
  const phases = [{
    number: '1',
    title: 'ATRACCIÓN DE CASOS DE ALTO VALOR',
    description: 'Segmentamos personas que en este momento tienen un problema legal activo en tu área de especialización y tienen la capacidad económica para pagar tus honorarios.',
    bullets: ['No llamadas de consulta gratuita.', 'Prospectos con caso real y presupuesto real.']
  }, {
    number: '2',
    title: 'AUTORIDAD DE FIRMA',
    description: 'Posicionamos tu firma como la referencia #1 en tu especialidad en tu ciudad.',
    bullets: ['Artículos de autoridad en medios locales.', 'Reseñas masivas en Google y Avvo.', 'Una Landing Page que comunica experiencia, resultados y confianza antes de que el cliente marque tu número.']
  }, {
    number: '3',
    title: 'FILTRO DE PRE-CALIFICACIÓN',
    description: 'El sistema hace las preguntas correctas antes de agendar la consulta.',
    bullets: ['Solo llegan a tu agenda los prospectos que califican para tus servicios.', 'Tu tiempo se mantiene enfocado en lo que más vale: cerrar casos.']
  }];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-[#0a0a0a] relative border-t border-white/5" data-id="element-35">
      <div className="max-w-5xl mx-auto" data-id="element-36">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-20" data-id="element-37">
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-gold" data-id="element-38">
            La Cura — Sistema A.C.E.™ Legal
          </h2>
        </motion.div>

        <div className="space-y-16 lg:space-y-24" data-id="element-39">
          {phases.map((phase, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="flex flex-col md:flex-row gap-8 md:gap-12 items-start" data-id="element-40">
              <div className="flex-shrink-0" data-id="element-41">
                <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-2xl bg-gold/10 border border-gold/20 flex items-center justify-center" data-id="element-42">
                  <span className="font-heading text-3xl sm:text-4xl font-bold text-gold" data-id="element-43">
                    {phase.number}
                  </span>
                </div>
              </div>

              <div className="flex-grow" data-id="element-44">
                <h3 className="font-heading text-2xl sm:text-3xl font-bold text-white mb-4 uppercase tracking-wide" data-id="element-45">
                  FASE {phase.number} — {phase.title}
                </h3>
                <p className="font-body text-lg text-gray-300 mb-8 leading-relaxed" data-id="element-46">
                  {phase.description}
                </p>

                <ul className="space-y-4" data-id="element-47">
                  {phase.bullets.map((bullet, bulletIndex) => <motion.li key={bulletIndex} initial={{
                opacity: 0,
                x: -10
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.4,
                delay: 0.2 + bulletIndex * 0.1
              }} className="flex items-start gap-3" data-id="element-48">
                      <CheckCircleIcon className="w-6 h-6 text-emerald shrink-0 mt-0.5" aria-hidden="true" data-id="element-49" />
                      <span className="font-body text-gray-200 text-base sm:text-lg" data-id="element-50">
                        {bullet}
                      </span>
                    </motion.li>)}
                </ul>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}